import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { heroFadeStyle } from './utils/heroFade';
import { useT } from './i18n';
import polyskullL from './assets/images/polyskullL.webp';
import crimsonL from './assets/images/polyskullL.webp'; // <--- placeholder till create
import goldenfaceL from './assets/images/goldenfaceL.webp';
import dimelL from './assets/images/dimelL.webp';
import yellowneckL from './assets/images/yellowneckL.webp';
import silverhandL from './assets/images/silverhandL.webp';
import palidaL from './assets/images/palidaL.webp';
import roseL from './assets/images/roseL.webp';
import peevishL from './assets/images/peevishL.webp';
import bloodsuckerL from './assets/images/bloodsuckerL.webp';
import galvanizadoL from './assets/images/galvanizadoL.webp';
import ironmaskL from './assets/images/ironmaskL.webp';
import purpaulL from './assets/images/purpaulL.webp';
import russL from './assets/images/russL.webp';
import woodyL from './assets/images/woodyL.webp';
import grapeyesL from './assets/images/grapeyesL.webp';
import trampoL from './assets/images/trampoL.webp';
import herberL from './assets/images/herberL.webp';
import mooseL from './assets/images/mooseL.webp';
import johnsonL from './assets/images/johnsonL.webp';

import polyskullM from './assets/images/polyskullM.webp';
import crimsonM from './assets/images/polyskullM.webp'; // <--- placeholder till create
import goldenfaceM from './assets/images/goldenfaceM.webp';
import dimelM from './assets/images/dimelM.webp';
import yellowneckM from './assets/images/yellowneckM.webp';
import silverhandM from './assets/images/silverhandM.webp';
import palidaM from './assets/images/palidaM.webp';
import roseM from './assets/images/roseM.webp';
import peevishM from './assets/images/peevishM.webp';
import bloodsuckerM from './assets/images/bloodsuckerM.webp';
import galvanizadoM from './assets/images/galvanizadoM.webp';
import ironmaskM from './assets/images/ironmaskM.webp';
import purpaulM from './assets/images/purpaulM.webp';
import russM from './assets/images/russM.webp';
import woodyM from './assets/images/woodyM.webp';
import grapeyesM from './assets/images/grapeyesM.webp';
import trampoM from './assets/images/trampoM.webp';
import herberM from './assets/images/herberM.webp';
import mooseM from './assets/images/mooseM.webp';
import johnsonM from './assets/images/johnsonM.webp';

import polyskull from './assets/images/polyskull.webp';
import crimson from './assets/images/crimson.webp';
import goldenface from './assets/images/goldenface.webp';
import dimel from './assets/images/dimel.webp';
import yellowneck from './assets/images/yellowneck.webp';
import silverhand from './assets/images/silverhand.webp';
import palida from './assets/images/palida.webp';
import rose from './assets/images/rose.webp';
import peevish from './assets/images/peevish.webp';
import bloodsucker from './assets/images/bloodsucker.webp';
import galvanizado from './assets/images/galvanizado.webp';
import ironmask from './assets/images/ironmask.webp';
import purpaul from './assets/images/purpaul.webp';
import russ from './assets/images/russ.webp';
import woody from './assets/images/woody.webp';
import grapeyes from './assets/images/grapeyes.webp';
import trampo from './assets/images/trampo.webp';
import herber from './assets/images/herber.webp';
import moose from './assets/images/moose.webp';
import johnson from './assets/images/johnson.webp';
import cracked from './assets/images/cracked.webp';
import ram from './assets/images/ram.webp';
import shadow from './assets/images/shadow.webp';
import kotsu from './assets/images/kotsu.webp';
import beard from './assets/images/beard.webp';

// ** PlaceHolder Images till create image version
import crackedM from './assets/images/goldenfaceM.webp';
import ramM from './assets/images/polyskullM.webp';
import shadowM from './assets/images/trampoM.webp';
import kotsuM from './assets/images/purpaulM.webp';
import beardM from './assets/images/herberM.webp';

import crackedL from './assets/images/goldenfaceL.webp';
import ramL from './assets/images/polyskullL.webp';
import shadowL from './assets/images/trampoL.webp';
import kotsuL from './assets/images/purpaulL.webp';
import beardL from './assets/images/herberL.webp';

import CranniLogo from './assets/images/crannislogo.png';
import loadinggif from './assets/utility/loading.gif';

const HeroNFT = () => {
  const t = useT();
  const [currentImage, setCurrentImage] = useState(loadinggif);
  const [, setLoading] = useState(true);

  const heroImagesL = [
    polyskullL,
    crimsonL,
    goldenfaceL,
    dimelL,
    yellowneckL,
    purpaulL,
    peevishL,
    bloodsuckerL,
    silverhandL,
    palidaL,
    roseL,
    galvanizadoL,
    ironmaskL,
    russL,
    woodyL,
    grapeyesL,
    trampoL,
    herberL,
    mooseL,
    johnsonL,
    crackedL,
    ramL,
    shadowL,
    kotsuL, 
    beardL
  ];

  const heroImagesM = [
    polyskullM,
    crimsonM,
    goldenfaceM,
    dimelM,
    yellowneckM,
    purpaulM,
    peevishM,
    bloodsuckerM,
    silverhandM,
    palidaM,
    roseM,
    galvanizadoM,
    ironmaskM,
    russM,
    woodyM,
    grapeyesM,
    trampoM,
    herberM,
    mooseM,
    johnsonM,
    crackedM,
    ramM,
    shadowM,
    kotsuM, 
    beardM
  ];

  const heroImages = [
    polyskull,
    crimson,
    goldenface,
    dimel,
    yellowneck,
    purpaul,
    peevish,
    bloodsucker,
    silverhand,
    palida,
    rose,
    galvanizado,
    ironmask,
    russ,
    woody,
    grapeyes,
    trampo,
    herber,
    moose,
    johnson,
    cracked,
    ram,
    shadow,
    kotsu, 
    beard
  ];

  const getRandomHeroImage = () => {
    const randomIndex = Math.floor(Math.random() * heroImages.length);
    return {
      lqImage: heroImagesL[randomIndex],
      mqImage: heroImagesM[randomIndex],
      hqImage: heroImages[randomIndex],
    };
  };

  useEffect(() => {
    const loadRandomHeroImage = () => {
      const randomImage = getRandomHeroImage();

      const screenWidth = window.innerWidth;
      if (screenWidth <= 490) {
        const img = new Image();
        img.src = randomImage.lqImage;
        img.onload = () => {
          setCurrentImage(randomImage.lqImage);
          setLoading(false);
        };
      } else if (screenWidth >= 490 && screenWidth <= 768) {
        const img = new Image();
        img.src = randomImage.mqImage;
        img.onload = () => {
          setCurrentImage(randomImage.mqImage);
          setLoading(false);
        };
      } else {
        const img = new Image();
        img.src = randomImage.hqImage;
        img.onload = () => {
          setCurrentImage(randomImage.hqImage);
          setLoading(false);
        };
      }
    };

    loadRandomHeroImage();

    window.addEventListener('resize', loadRandomHeroImage);

    return () => {
      window.removeEventListener('resize', loadRandomHeroImage);
    };
  }, []);

  const backgroundImageStyle = {
    backgroundColor: '#000000',
    backgroundImage: `url(${currentImage})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'left center',
    ...heroFadeStyle,
  };

  return (
    <section
      className="relative flex w-full items-center overflow-hidden"
      style={{ maxHeight: '620px' }}
    >
      {/* Artwork layer, faded at the bottom so the hero dissolves into the page. */}
      <div
        aria-hidden="true"
        className="absolute inset-0 bg-left bg-no-repeat xl:bg-contain"
        style={backgroundImageStyle}
      >
        <div className="absolute inset-0 bg-gradient-to-l from-black via-black/70 to-black/20" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-transparent to-black/50" />
      </div>

      <div className="relative mx-auto flex w-full max-w-screen-2xl justify-end px-4 py-16 sm:px-8 md:min-h-[560px] lg:min-h-[620px] lg:px-10 min-[1920px]:items-start min-[1920px]:pt-24">
        <div className="max-w-xl lb-animate-in">
          <div className="flex items-center gap-4">
            <img
              src={CranniLogo}
              alt="Cranni Societas"
              className="h-14 w-auto sm:h-16"
            />
            <span className="lb-chip lb-chip-gold">{t('heroNft.seats')}</span>
          </div>

          <h2 className="lb-heading mt-6 text-[2.25rem] leading-[0.98] sm:text-5xl">
            {t('heroNft.badge')}
            <span className="mt-1 block lb-gold-text">the key to automated gaming</span>
          </h2>

          <p className="mt-5 font-medium text-base leading-relaxed text-white/80 sm:text-lg">
            {t('heroNft.body')}
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link to="/nftnodes?section=mintbuy" className="lb-btn lb-btn-gold lb-btn-lg">
              {t('heroNft.mint')}
            </Link>
            <a
              href="https://docs.luckblocks.com/cranni-societas-nftnodes"
              target="_blank"
              rel="noreferrer"
              className="lb-btn lb-btn-ghost lb-btn-lg"
            >
              {t('heroNft.docs')}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroNFT;
